import React, { lazy, Suspense, memo, useEffect } from "react";

import { useSelector } from "react-redux";
import { ConfigProvider } from "antd";
import antdEnUS from "antd/es/locale/en_US";
import Loading from "components/shared-components/Loading";
import { lightTheme, darkTheme } from "configs/ThemeConfig";
import { resources } from "lang";
import useBodyClass from "utils/hooks/useBodyClass";
import Routes from "routes";
import { preloadPublicRoutes } from "utils/preloadPublicRoutes";

const AppLayout = lazy(() => import("./AppLayout"));
const AuthLayout = lazy(() => import("./AuthLayout"));

const getAntdLocale = (locale) => {
  const key = String(locale || "en")
    .split("-")[0]
    .toLowerCase();
  return resources?.[key]?.antd || resources?.en?.antd || antdEnUS;
};

const Layouts = () => {
  const token = useSelector((state) => state.auth.token);
  const blankLayout = useSelector((state) => state.theme.blankLayout);

  const Layout = token && !blankLayout ? AppLayout : AuthLayout;

  const locale = useSelector((state) => state.theme.locale);

  const direction = useSelector((state) => state.theme.direction);

  const currentTheme = useSelector((state) => state.theme.currentTheme);

  const antdLocale = getAntdLocale(locale);

  useBodyClass(`dir-${direction}`);

  useEffect(() => {
    preloadPublicRoutes();
  }, []);

  const themeConfig = currentTheme === "light" ? { ...lightTheme } : { ...darkTheme };

  return (
    <ConfigProvider theme={themeConfig} direction={direction} locale={antdLocale}>
      <Suspense fallback={<Loading cover="page" />}>
        <Layout>
          <Routes />
        </Layout>
      </Suspense>
    </ConfigProvider>
  );
};

export default memo(Layouts);
